import { createFileRoute } from "@tanstack/react-router";
import { McpKeysPage } from "@/components/McpKeys";

function RouteComponent() {
  return <McpKeysPage />;
}

export const Route = createFileRoute("/_authenticated/mcp-keys/")({
  component: RouteComponent,
  staticData: { page: "admin" },
});
